/** Visible area relative to the portion of a section that can fit on screen. */
export function sectionVisibility(rect: { top: number; bottom: number; left: number; right: number; width: number; height: number }, width: number, height: number) {
  const area = Math.min(rect.width, width) * Math.min(rect.height, height);
  if (area <= 0) return 0;
  const visibleWidth = Math.max(0, Math.min(rect.right, width) - Math.max(rect.left, 0));
  const visibleHeight = Math.max(0, Math.min(rect.bottom, height) - Math.max(rect.top, 0));
  return Math.min(1, visibleWidth * visibleHeight / area);
}
